import { GridFilter, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { CostSpent } from "../../cost/model/costspent.model";
import { Invoice } from "../../order/model/invoice.model";
import { ReceiptPaymentModel } from "../../order/model/receiptpayment.model";
import { GenderEnum } from "../../parties/model/customer.model";
import { CashierSettlementModel } from "./usersettlement.model";

export class SettlementReadInvoiceModel {
  Status: number;
  SettledUserlId: number;
  UntilDate: Date;
  UntilTime: string;
  InvoiceIds: number[];
  Invoices: PagingDataResult<Invoice>;
  CostSpents: PagingDataResult<CostSpent>;
  ReceiptPayments: PagingDataResult<ReceiptPaymentModel>;
  Settlements: PagingDataResult<CashierSettlementModel>;
  Filters: GridFilter[];
  constructor() {
    this.Invoices = null;
    this.ReceiptPayments = null;
    this.Settlements = null;
  }
}

export enum SettlementReadInvoiceEnum {
  Passive = 0,
  Pending = 1,
  Cancelled = 2,
  Cleard = 3,
  Personnel = 4,
  Customer = 5,
  Delivery = 6,
  Debit = 7,
  Credit = 8,
  Discount = 9,
  Deleted = 10,
  CostSpent = 11,
  DriverShippingCostReduced = 12,
  PaymentPersonnel = 13,
  PaymentLink = 14,
  OnlinePayment = 15,
  Deposit = 16,
}
